import React from "react";
import ReactECharts from "echarts-for-react";
import {ReactSingleSelect} from "~/components";

const UsersPerMonthBarChart = ({websiteVisitorYears = []}) => {
    const dataMonth = websiteVisitorYears.map(item => item.Values);
    const option = {
        tooltip: {
            trigger: "axis"
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
        },
        xAxis: {
            type: "category",
            data: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
            axisTick: { show: false }
        },
        yAxis: {
            type: "value"
        },
        series: [
            {
                name: "Users",
                type: "bar",
                barWidth: "50%",
                data: dataMonth,
                itemStyle: {
                    color: "#2f5aa2",
                    borderRadius: [4, 4, 0, 0]
                }
            }
        ]
    };

    const optionsDDL = [
        {
            Text: "Text",
            Values: "123"
        }
    ]

    return (
        <div className="card" style={{ height: "450px" }}>
            <div className="card-body">
                <div className="d-flex justify-content-between">
                    <div>
                        <h5>User Website Visistor</h5>
                        <p className="fs-9 fw-semibold mb-0">Users across countries</p>
                    </div>
                    <div className="col-xl-6">
                        <ReactSingleSelect
                            options={optionsDDL}
                            placeholder="Select year..."
                        />
                    </div>
                </div>
                <ReactECharts className='w-100' style={{height: "370px"}} option={option} />
            </div>
        </div>
    );
};

export default UsersPerMonthBarChart;
